import { render, staticRenderFns } from "./MarcoCaptura.vue?vue&type=template&id=c21fe92e&scoped=true&"
import script from "./MarcoCaptura.vue?vue&type=script&lang=js&"
export * from "./MarcoCaptura.vue?vue&type=script&lang=js&"
import style0 from "./MarcoCaptura.vue?vue&type=style&index=0&id=c21fe92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21fe92e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VTextField})
